import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle, ChevronRight, MessageCircle, RotateCw } from "lucide-react";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
api.interceptors.request.use((c) => { const t = localStorage.getItem("feemitra_token"); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });
const errOf = (e, d) => { const x = e.response?.data?.detail; return typeof x === "string" ? x : d; };

const LABEL = { accepted: "Accepted by AiSensy", sent: "Sent", delivered: "Delivered", read: "Read", failed: "Failed", skipped: "Skipped", shared: "Shared manually" };
const TONE = { failed: "overdue", skipped: "pending", accepted: "pending", delivered: "paid", read: "paid", sent: "paid" };

export function WaStatusCell({ r }) {
  const st = r.status;
  return <>
    <span className={`status ${TONE[st] || "paid"}`} data-testid={`reminder-status-${r.id}`}>{LABEL[st] || st}</span>
    <small>{r.provider === "mock" ? "MOCK" : r.channel === "email" ? "Email" : "WhatsApp"}{r.resend_count ? ` · resent ${r.resend_count}x` : ""}</small>
    {st === "failed" && r.failure_reason && <small className="wa-fail-reason" title={r.failure_reason} data-testid={`reminder-fail-reason-${r.id}`}>{r.failure_reason}</small>}
  </>;
}

export function WaRowActions({ r, notify, onDone }) {
  const [busy, setBusy] = useState("");
  if (r.channel !== "whatsapp" || r.status !== "failed") return null;
  const resend = async () => {
    setBusy("re");
    try { const { data } = await api.post(`/reminders/${r.id}/resend`); notify(`Dobara bheja — AiSensy ne accept kiya (${data.resends_left} resend baaki)`); onDone(); }
    catch (e) { notify(errOf(e, "Resend failed"), true); onDone(); } finally { setBusy(""); }
  };
  const manual = async () => {
    const w = window.open("", "_blank"); setBusy("wa");
    try { const { data } = await api.post(`/reminders/${r.id}/manual-link`); if (w) w.location.href = data.url; else window.location.href = data.url; notify("WhatsApp khul gaya — Send dabayein"); }
    catch (e) { if (w) w.close(); notify(errOf(e, "Could not open WhatsApp"), true); } finally { setBusy(""); }
  };
  return <div className="wa-row-actions">
    {r.can_resend && <button className="secondary-btn small" disabled={!!busy} onClick={resend} data-testid={`reminder-resend-${r.id}`}><RotateCw size={13} /> {busy === "re" ? "Bhej rahe…" : `Resend (${r.resends_left})`}</button>}
    <button className="primary-btn small" disabled={!!busy} onClick={manual} data-testid={`reminder-manual-${r.id}`}><MessageCircle size={13} /> WhatsApp se bhejein</button>
  </div>;
}

export function WaFailAlert({ onOpen, refreshKey = 0 }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/reminders/whatsapp-failures").then(r => setD(r.data)).catch(() => {}); }, [refreshKey]);
  if (!d?.failed) return null;
  return <div className="warn-box wa-fail-alert" data-testid="wa-fail-alert">
    <AlertTriangle size={18} />
    <div><b data-testid="wa-fail-count">Pichhle 7 din mein {d.failed} WhatsApp message fail hue</b>
      <small>{d.last_reason || "Parents tak message nahi pahuncha."} Resend karein ya “WhatsApp se bhejein” se khud bhejein.</small></div>
    {onOpen && <button className="secondary-btn small" onClick={onOpen} data-testid="wa-fail-alert-open">Dekhein <ChevronRight size={14} /></button>}
  </div>;
}
